<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="48.5rem"
      height="28.125rem"
      :before-close="handleClose"
      :center="true"
      :footer="null"
      custom-class="Logins"
    >
      <div>
        <img src="../assets/images/组 129@2x.png" alt />
      </div>
      <div class="Right">
        <el-row type="flex" class="row-bg header" justify="space-between">
          <h3>账户登录</h3>
          <img src="../assets/images/clsoes.png" @click="dialogVisible = false" alt />
        </el-row>
        <div class="inputName">
          <el-input placeholder="请输入账号/手机号" v-model="userName">
            <img class="InputIcon" slot="prefix" src="../assets/images/用户名@2x.png" alt />
          </el-input>
        </div>
        <div>
          <el-input placeholder="请输入您的密码" show-password v-model="userPsd">
            <img class="InputIcon" slot="prefix" src="../assets/images/密码@2x.png" alt />
          </el-input>
        </div>
        <el-row type="flex" class="row-bg rememberPas" justify="space-between">
          <el-checkbox v-model="checked">记住账号密码</el-checkbox>
          <span class="forgetPas" @click="ToFindPsd">忘记密码?</span>
        </el-row>
        <div>
          <el-button class="LoginBtn" @click="ToLogin()" type="primary">登录</el-button>
        </div>
        <el-row type="flex" class="row-bg rememberPas" justify="space-between">
          <span @click="WechatLogin">
            <img src="../assets/images/微信登录@2x.png" alt />
            微信登录
          </span>
          <!-- <router-link to="/Register" @click="dialogVisible = false">立即注册</router-link> -->
          <span @click="toReg" style="color: #2769DC;">立即注册</span>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { library } from '@/api/url'
import { postAction } from '@/api/api'
export default {
  data() {
    return {
      dialogVisible: false,
      checked: false,
      userName: '',
      userPsd: '',
    }
  },
  created() {
    this.userName = localStorage.getItem('userName')
    this.userPsd = localStorage.getItem('userPsd')
    if (this.userName && this.userPsd) {
      this.checked = true
    }
  },
  mounted() {
    let vm = this
    vm.$bus.$on('dialogVisible', (e) => {
      // console.log(e);
      vm.dialogVisible = e
    })

    window.addEventListener('keydown', function (e) {
      if (e.keyCode == 13 && vm.dialogVisible) {
        vm.ToLogin()
      }
    })
  },
  computed: {
    IsChange() {
      // console.log(this.$store.state);
    },
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    ToLogin() {
      if (!this.userName) {
        this.$message.error('请输入正确的用户名!')
        return
      }
      if (!this.userPsd) {
        this.$message.error('请输入正确的密码!')
        return
      }
      let data = {
        action: 'User_Login',
        UserName: this.userName,
        PassWord: this.userPsd,
        ChkRemember: 0,
      }

      postAction(library, this.$qs.stringify(data)).then((res) => {
        // console.log(res);
        if (res.status == 'y') {
          this.$message.success('登录成功!')
          if (this.checked) {
            localStorage.setItem('userName', this.userName)
            localStorage.setItem('userPsd', this.userPsd)
          } else {
            localStorage.setItem('userName', '')
            localStorage.setItem('userPsd', '')
          }
          this.dialogVisible = false
          this.$emit('success')
          this.$bus.$emit('LoginSuccess', true)
        } else {
          this.$message.error(res.info)
        }
      })
    },
    ToFindPsd() {
      this.$router.push('/findPsd')
    },
    toReg() {
      this.dialogVisible = false
      this.$router.push('/Register')
    },
    //微信登录
    WechatLogin() {
      window.location.href =
        'https://open.weixin.qq.com/connect/qrconnect?appid=wxcb2133e3bb7d5510&redirect_uri=' +
        this.Urls+'/cement/index.html&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
    },
  },
}
</script>

<style lang='scss' scoped>
/deep/ .Logins {
  height: 28.125rem;
  border-radius: 0.625rem;
}
/deep/ .el-dialog__body {
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  img {
    width: 22.5rem;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
.Right {
  width: 100%;
  padding: 2.1875rem 2.1875rem 3.0625rem;
}
.header {
  h3 {
    font-size: 1.5625rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  img {
    width: 1.375rem;
    height: 1.375rem;
  }
}
/deep/ .el-input__inner {
  height: 3.125rem;
  padding-left: 2.2rem !important;
}
.InputIcon {
  width: 1.25rem !important;
  height: 1.25rem;
  margin-top: 0.9375rem;
}
.inputName {
  margin: 2.875rem 0 1.25rem;
}
.rememberPas {
  font-size: 0.875rem;
  margin: 1.25rem 0 2.75rem;
  color: #999;
  cursor: pointer;
  .forgetPas {
    color: #f24949;
  }
  img {
    width: 1.25rem;
  }
}
.LoginBtn {
  width: 100%;
  font-size: 1.125rem;
  /* width: 346px; */
  height: 3.125rem;
  background: #2769dc;
  opacity: 1;
  border-radius: 0.25rem;
  line-height: 0.75rem;
}
/deep/.el-checkbox__input {
  width: 1rem;
  height: 1rem;
}
</style>